export default "__VITE_ASSET__hRJWEvq6__"